<div class="role-deletion-confirmation">
  <h3 class="role-deletion-confirmation__title">
    {{ 'monitoring.roles.modal.action-confirmation-modal.deletion-warning-title' | translate }}
  </h3>

  <div class="role-deletion-confirmation__description">
    {{ 'monitoring.roles.modal.action-confirmation-modal.deletion-warning-text' | translate }}
  </div>

  <div class="role-deletion-confirmation__buttons-container">
    <lib-button
      (click)="confirm()"
      buttonStyle="transparent-tertiary"
      buttonSize="large"
    >
      {{ 'monitoring.roles.modal.action-confirmation-modal.delete-role' | translate }}
    </lib-button>

    <lib-button
      (click)="cancel()"
      buttonSize="large"
    >
      {{ 'monitoring.roles.modal.action-confirmation-modal.abort-deletion' | translate }}
    </lib-button>
  </div>
</div>
